import React from 'react';
import i18next from 'i18next';
import en from './i18n/en';
import jp from './i18n/jp';

i18next.addResourceBundle('en', 'recyclePage', en);
i18next.addResourceBundle('jp', 'recyclePage', jp);

const RecycleConfig = {
	settings: {
		layout: {
			config: {}
		}
	},
	routes: [
		{
			path: '/deleted-info',
			component: React.lazy(() => import('./Recycle'))
		}
	]
};

export default RecycleConfig;
